import { PayloadAction } from '@reduxjs/toolkit';
import { IRootState } from './types';

const reducers = {
  setTokenDetails: (state: IRootState, action: PayloadAction<IRootState['tokenDetails']>) => ({
    ...state,
    tokenDetails: action.payload,
  }),
  setAuthenticateUser: (state: IRootState, action: PayloadAction<IRootState['authenticateUser']>) => ({
    ...state,
    authenticateUser: action.payload,
  }),
};

export {
  reducers,
};
